/* eslint-disable import/no-cycle */
import styled, { css } from 'styled-components'

/* eslint-disable import/no-cycle */
import Button from 'components/button'
import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Bold = styled.span`
  font-weight: 600;
`

export const ModalContent = styled.div`
  margin: 38px 181px 13px;

  ${mediaQueries.tablet`
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `};
`

export const Text = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.doveGray};
  & a {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: underline;
  }
  .VerticalWrapper & {
    color: ${({ theme }) => theme.colors.gray60};
  }
`

export const Italic = styled.div`
  font-style: italic;
  display: inline;
`

export const Small = styled.div`
  font-size: 12px;
  line-height: 1.25;
`

export const Margin = styled.div`
  margin-top: 6px;
`

export const VerticalWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
`

export const HorizontalWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  width: 60%;

  ${mediaQueries.mobile`
    grid-template-rows: repeat(2, 1fr);
    margin-top: 30px;
    grid-gap: 10px;
    width: 100%;
  `};
`

export const CustomRow = styled.div`
  display: flex;
  width: 100%;
  padding: 0 0 33px 0;
  flex-wrap: wrap;

  ${mediaQueries.tablet`
    padding: 0 0 25px 0;
  `};
`

export const CustomColumn = styled.div`
  display: flex;

  ${props => (props.width ? `width: ${props.width}` : 'flex: 1')};
  ${props =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `};
  ${props =>
    props.mobileWidth &&
    css`
      ${mediaQueries.mobile`
        width: ${props.mobileWidth};
      `};
    `};
`

export const CollapsibleHeader = styled.button.attrs(props => ({
  className: props.e2eClass,
  type: 'button'
}))`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.blue};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 15px;
  border: none;
  width: 100%;

  ${mediaQueries.tablet`
    padding: 7px 60px;
    margin-bottom: 1px;
  `};

  ${mediaQueries.mobile`
    padding: 7px 12px;
  `};
`

export const CollapsibleLabel = styled.label`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 18px;
`

export const TermsAndConditionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 22px;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.grayLighter};
  margin: 20px 0 0 0;

  ${mediaQueries.tablet`
    margin: 20px 65px 0;
  `};

  ${mediaQueries.mobile`
    margin: 20px 20px 0;
  `};
`

export const SubmitButtonWrapper = styled.div`
  width: 100%;
  padding: ${({ isSublos }) => (isSublos ? '0' : '15px 20px 0')};

  ${({ isCreditForm }) =>
    isCreditForm &&
    css`
      justify-content: center;
      display: flex;
    `};

  ${({ isStandardButton }) =>
    isStandardButton &&
    css`
      margin: 0 auto;
      width: 244px;
      padding: 15px 0;
      ${mediaQueries.mobile`
        padding: 22px 0 15px;
        width: 100%;
      `};
    `};
`

export const ButtonWithPadding = styled(Button)`
  width: 100%;
  padding: 15px 55px;
  border: solid 1px ${({ theme }) => theme.colors.blue};
`

export const RedressText = styled.label.attrs(() => ({
  className: e2eClasses('passengerData.redressText')
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 1em;
  font-family: ${({ theme }) => theme.fonts.regular};
`

export const CheckboxWrapper = styled.div`
  padding: 10px 0 0;
`

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ paddingTop }) => paddingTop && 'padding-top: 10px;'};

  && li {
    font-family: ${({ theme }) => theme.fonts.regular};
  }

  list-style-type: ${({ children }) => (children.length === 1 ? `none` : `disc`)};
`

export const MessageText = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  padding-bottom: 10px;
`

export const HorizontalSeparator = styled.div`
  height: 25px;
`

export const MessageContainer = styled.div``

export const ButtonContainer = styled.div`
  ${({ isSublos }) =>
    isSublos
      ? `
   display: flex;
   column-gap: 16px;
   width: 100%;
   padding: 2.5rem 0;
  `
      : `
   align-self: center;
   padding: 16px;
   width: 20%;
  `}

  ${mediaQueries.tablet`
    ${({ isSublos }) =>
      isSublos
        ? `
        gap: 16px;
        flex-direction: column;
        flex: 1;`
        : `
         width: 50%;
        `}
  `};

  ${mediaQueries.mobile`
    ${({ isSublos }) =>
      isSublos
        ? `
        gap: 16px;
        flex-direction: column;
        flex: 1;`
        : `
         width: 100%;
        `}
  `};
`

export const ButtonStyled = styled(Button)`
  ${({ isSublos }) =>
    isSublos
      ? `
      width: 200px;
      column-gap: 16px;
    `
      : `
      text-align: center;
   `}

  ${mediaQueries.tablet`
     ${({ isSublos }) => isSublos && 'width: 100%; gap: 16px;'}
  `};
`

export const ButtonRowContainer = styled.div`
  align-self: center;
  padding: 0px;
  margin-top: 50px;
  width: 100%;

  ${mediaQueries.tablet`
    width: 50%;
  `};

  ${mediaQueries.mobile`
    width: 100%;
  `};
`

export const DateDivision = styled.div.attrs(() => ({
  className: e2eClasses('paymentDetails.cardExpiredBar')
}))`
  display: flex;
  width: 5%;
  margin: 0 8px;
  align-items: center;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.doveGray};
`

export const BINMessageLabel = styled.label``

export const AddressWrapper = styled.div.attrs(props => ({
  className: props.e2eClass
}))``

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet`
    margin-bottom: 10px;
  `};

  ${mediaQueries.mobile`
    padding: 10px 20px;
    background: ${({ theme }) => theme.colors.grayLighter};
  `};
`

export const DashedSeparator = styled.div`
  width: 100%;
  margin-bottom: 24px;
  ${({ showSeparator, theme }) => showSeparator && `border-top: 1px dashed ${theme.colors.blue};`};
`

export const AncillariesBannerWrapper = styled.div`
  padding: 35px 0;
`

export const InputContainer = styled.div.attrs(props => ({
  className: `${e2eClasses('common.inputBox') || ''}${props.e2eClass || ''}`
}))`
  ${({ noFlex, flex }) =>
    !noFlex &&
    `
      display: flex;
      flex: ${flex || 0.32};
  `}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ gap }) => gap && `gap: ${gap};`}
  ${({ alignSelf }) => alignSelf && `align-self: ${alignSelf};`}
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ width, theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? 'width: 26%;'
      : width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ flexWrap }) => flexWrap && `flex-wrap: ${flexWrap};`}
  min-height: ${({ minHeight }) => (minHeight ? minHeight : '100px')};
  ${({ marginRight }) => marginRight && `margin-right: 24px;`}

  ${mediaQueries.mobile`
    flex: 1;
    flex-basis: 100%;
  `}
`

export const InputRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 18px;
  align-items: flex-start;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  ${({ isLast }) =>
    isLast &&
    `
    margin-bottom: 32px;
  `}
  ${({ width }) => width && `width: ${width};`}
  ${({ gap }) => gap && `gap: ${gap};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ borderBottom, theme }) =>
    borderBottom && theme && `border-bottom: 1px solid ${theme.colors.blue};`}
  ${({ paddingBottom }) => paddingBottom && `padding-bottom: 47px;`}
  ${mediaQueries.mobile`
    width: 100%;
  `}
`

export const Label = styled.label.attrs(props => ({
  className: `${e2eClasses('common.inputTitle') || ''}${props.e2eClass || ''}`,
  htmlFor: props.forId
}))`
  display: flex;
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  padding: 15px 0;
  ${({ fontSize }) =>
    fontSize &&
    `
    font-size: ${fontSize};
  `}
`

export const Container = styled.div`
  padding: 0;
`
export const SubmitButtonContainer = styled.div`
  flex: 0.32;
  margin-bottom: 40px;
  ${mediaQueries.mobile`
    flex: 1;
  `}
`

export const FeedbackContainer = styled.div`
  display: flex;
  ${({ noMargin }) => !noMargin && `margin-bottom: 32px;`}
`
export const FeedbackTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.bold};
  ${({ margin }) => margin && `margin: ${margin};`}
`
export const TitleForm = styled.h2`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.blue};
  margin: 20px 0;
  font-weight: 600;
  ${({ margin }) => margin && `margin: ${margin};`}
`

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.gray60};
  margin: ${({ margin }) => (margin ? margin : '20px 0')};
  line-height: 1.5;
  ${({ fontSize }) => `font-size: ${fontSize ? fontSize : '16px'};
  `}
`

export const Description_Bold = styled.p`
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.doveGray};
  margin: ${({ margin }) => (margin ? margin : '20px 0')};
  font-size: 16px;
  line-height: 1.5;
`

export const FormContainer = styled.div`
  ${mediaQueries.tablet`
    width: auto;

  `}

  ${mediaQueries.mobile`
    width: auto;

  `}
`

export const LabelGray = styled.label.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.label')}${props.e2eClass}`
}))`
  color: ${({ theme }) => theme.colors.gray60};
  margin-top: ${({ noMargin }) => (noMargin ? '0' : '7px')};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
`

export const SeparatorVertical = styled.div`
  height: 5px;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  margin: ${({ margin }) => (margin ? margin : '0')};
  text-decoration: underline;
  cursor: ${({ cursor }) => (cursor ? cursor : '')};
  min-width: ${({ minWidth }) => (minWidth ? minWidth : '')};
`

export const LabelInformation = styled.label`
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.regular};
  line-height: 22px;
`

export const BoldText = styled.b``

export const Separator = styled.div`
  height: 15px;
`
export const DivideLine = styled.hr`
  margin: 40px 0px;
  opacity: 0.3;
  border: 0;
  border-top: ${({ theme }) => `1px solid ${theme.colors.blue}`};
`

export const DivideDashed = styled.div`
  margin: 40px 0px;
  border: ${({ theme }) => `dashed 1px ${theme.colors.blue}`};
`

export const DivideDotted = styled.div`
  margin: 40px 0px;
  border: ${({ theme }) => `dotted 1px ${theme.colors.blue}`};
`

export const RefundInformationContainer = styled.div`
  margin-bottom: 48px;
`

export const ResultWrapper = styled.div`
  padding: 50px 0;
`

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 40px;
`

export const Card = styled.div`
  color: ${({ theme }) => theme.colors.doveGray};
  margin: ${({ margin }) => (margin ? margin : '10px')};
  width: 100%;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  ${({ isMobile }) =>
    isMobile &&
    `
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `}
`

export const CardLeft = styled.div`
  color: ${({ theme }) => theme.colors.doveGray};
  padding: ${({ padding }) => (padding ? padding : '10px')};
  width: 70%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 400px;
  ${({ isMobile }) =>
    isMobile &&
    `
    height:fit-content;
    width: 100%;
  `}
`

export const ImageCard = styled.div`
  margin: ${({ margin }) => (margin ? margin : '0 0 0 8px')};
  width: ${({ width }) => (width ? width : '')};
  border-radius: 0 8px 8px 0;
  height: ${({ height }) => (height ? height : '227px')};
  background: url(${({ background }) => background});
  background-repeat: no-repeat;
  background-position: center;
`

export const TitleCard = styled.p`
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.blue};
  margin: ${({ margin }) => (margin ? margin : '8px 0')};
  font-size: 16px;
  line-height: 1.5;
`

export const DescriptionContent = styled.div`
  padding: ${({ padding }) => (padding ? padding : '0')};
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const DescriptionContentValues = styled.div`
  margin: ${({ margin }) => (margin ? margin : '3px 0')};
  display: flex;
  justify-content: start;
`

export const Description_label = styled.p`
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.doveGray};
  margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
  font-size: 16px;
  white-space: nowrap;
  line-height: 1.5;
`
export const Contact_label = styled.p`
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.doveGray};
  margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
  text-decoration: underline;
  margin: 10px 0 5px;
  font-size: 16px;
`

export const Description_value = styled.p`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 16px;
  line-height: 1.5;
`

export const FooterPurchaseLoaderWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  right: 50%;
  transform: translateX(50%);
  width: 100%;
`

const display = ({ display }) => css`
  ${display ? display : ''}
`

export const FormWrapper = styled.div`
  display: ${display};
`

export const Form = styled.form`
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
`

export const InputRowWrapper = styled.form`
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  padding-left: 10px;
  padding-right: 10px;
`
